import { gql } from "@apollo/client";

export const CLIP_QUALITY_CONFIGS = gql`
  query ClipQualityConfigs {
    clipQualityConfigs {
      configs {
        configName
        settings {
          resolution
          framerate
          frameBlendBlur
        }
        requiredUserGroup
        canApply
      }
      currentConfig
      needsConfChange
    }
  }
`;

export const UPDATE_CLIP_QUALITY_CONFIG = gql`
  mutation UpdateClipQualityConfig($configName: String!) {
    updateClipQualityConfig(configName: $configName) {
      success
      errors {
        field
        code
        message
      }
    }
  }
`;
